import { getToken } from './auth';

/**
 * Retrieves the images for the Validation GUI in different resolutions.
 * The images can be retrieved by calling the URL specified under `PreviewSrc`
 * and `Src`.
 *
 * @param id - `ImageId` received with response from `needForAction` or `autoprocessed` `InvoiceContainers`.
 *
 */
export function generateImageURL(id: UUID): string {
  const token = getToken();
  return `/api/images?iid=${id}${token ? `&at=${token}` : ''}`;
}
